import { ApolloClient, InMemoryCache, createHttpLink, from } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { DISTRIBUTORS_QUERY } from "graphql/distributors";

const getBearerToken = () => {
  try {
    return localStorage.getItem("accessToken") || "";
  } catch {
    return "";
  }
};

let distributorsClient = null;

const getDistributorsClient = () => {
  if (distributorsClient) {
    return distributorsClient;
  }

  const httpLink = createHttpLink({
    uri: process.env.REACT_APP_DOORSHARP_GRAPHQL_ENDPOINT,
  });

  const authLink = setContext((_, { headers }) => ({
    headers: {
      ...headers,
      "Content-Type": "application/json",
      ...(getBearerToken() ? { Authorization: `Bearer ${getBearerToken()}` } : {}),
    },
  }));

  distributorsClient = new ApolloClient({
    link: from([authLink, httpLink]),
    cache: new InMemoryCache(),
    defaultOptions: {
      query: {
        fetchPolicy: "network-only",
        errorPolicy: "all",
      },
    },
  });

  return distributorsClient;
};

export async function fetchDistributors(timePeriod = "YTD", highlightsTimePeriod = "YTD") {
  try {
    const client = getDistributorsClient();

    const { data } = await client.query({
      query: DISTRIBUTORS_QUERY,
      variables: { timePeriod, highlightsTimePeriod },
      fetchPolicy: "network-only",
    });

    console.log("Distributors GraphQL response:", data);
    return data;
  } catch (error) {
    console.error("Distributors GraphQL error:", error);
    throw error;
  }
}

